// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import { BootstrapVue, BootstrapVueIcons , IconsPlugin } from "bootstrap-vue"
// import {}
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import dotenv from "dotenv";
dotenv.config();

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Vue.use(IconsPlugin)

Vue.config.silent = true
Vue.config.productionTip = false


Vue.use(IconsPlugin)
/* eslint-disable no-new */
/* eslint-disable */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js